import React, { useContext } from "react";
import styles from './DetailsLayout.module.scss'
import FoldingBlock from "../../../../../../../components/folding/FoldingBlock";
import { FoldingContentContext } from "../../../../../../../components/folding/FoldingContent";

function DetailsLayout({title, icon, iconColor, iconOpacity, titleWeight, children, folded}) {

    const foldingContext = useContext(FoldingContentContext);

    return (
        <div
            className={styles.layout}
            style={{
                '--dl-iconColor': iconColor,
                '--dl-iconOpacity': iconOpacity,
                '--dl-titleWeight': titleWeight,
            }}
        >
            <div className={styles.layout__icon}>
                <i className={`${icon ? icon : 'fas fa-cloud'} ${styles.layout__icon__item}`}/>
            </div>
            <FoldingBlock
                className={styles.layout__folding}
                title={title}
                folded={folded}
                onFoldSwitch={() => setTimeout(() => foldingContext.recalculateHeight(), 80)}
            >
                {children}
            </FoldingBlock>
        </div>
    )
}

export default DetailsLayout